import { render, staticRenderFns } from "./LoadingScreen.vue?vue&type=template&id=3e655392&scoped=true&"
import script from "./LoadingScreen.vue?vue&type=script&lang=ts&"
export * from "./LoadingScreen.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingScreen.vue?vue&type=style&index=0&id=3e655392&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e655392",
  null
  
)

export default component.exports